export const Colors = {
    themeColor:"#36B4FF"
}